import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

/** A postcode as a comparison key - 'm1 1aa' and 'M11AA' are the same postcode. */
const postcodeKey = (postcode?: string) => (postcode ?? '').replace(/\s+/g, '').toUpperCase();

/**
 * Whether the sender and recipient share a postcode inside the UK - usually a sign the recipient's
 * address was filled in with the sender's. Case and spacing are ignored. Abroad a matching postcode
 * is just a coincidence of numbering, so only UK-to-UK items count, and a missing postcode is never
 * a match.
 */
export const isSameUkPostcode = (item: Pick<SmartSendItemApiModel, 'Sender' | 'Recipient'>): boolean => {
  const sender = postcodeKey(item.Sender?.Postcode);
  return (
    sender !== '' &&
    sender === postcodeKey(item.Recipient?.Postcode) &&
    ['GB', 'GBR'].includes(item.Sender?.CountryIsoCode ?? '') &&
    ['GB', 'GBR'].includes(item.Recipient?.CountryIsoCode ?? '')
  );
};
